<script lang="ts">
    import { createEventDispatcher, onMount, tick } from 'svelte'
    import Fa from 'svelte-fa'
    import { faSave } from '@fortawesome/free-solid-svg-icons'

    const dispatch = createEventDispatcher()

    export let discountFixed: number
    export let discountPercentage: number

    let _discountFixed: number
    let _discountPercentage: number

    function updateDiscount() {
        if (type === 'fixed') {
            discountFixed = discount
            discountPercentage = 0
        } else {
            if (discount < 0 || discount > 100) {
                window.error('Desconto inválido')
                return
            }
            discountFixed = 0
            discountPercentage = discount
        }
        dispatch('change')
    }

    let discount = 0
    onMount(async () => {
        discount = discountFixed + discountPercentage
        if (discountPercentage > 0) type = 'percentage'
        await setFocus()
    })

    async function setFocus() {
        await tick()
        if (type === 'fixed') {
            inputFixed.focus()
            await tick()
            inputFixed.select()
        } else {
            inputPercentage.focus()
            await tick()
            inputPercentage.select()
        }
    }

    let inputFixed
    let inputPercentage

    let type: 'fixed' | 'percentage' = 'fixed'
</script>

<div class="root m-bottom-sm">
    <div class="grid-act">
        <div class="spacer" />
        <button class="btn btn-primary" on:click={updateDiscount}><Fa icon={faSave} /> Aplicar</button>
    </div>
    <div class="grid-form">
        <div class="row">
            <div class="col">
                <div class="btn-group mb-3" role="group">
                    <button type="button" on:click={() => (type = 'fixed')} class="btn btn-secondary" class:btn-primary={type === 'fixed'}>Fixo</button>
                    <button type="button" on:click={() => (type = 'percentage')} class="btn btn-secondary" class:btn-primary={type === 'percentage'}
                        >Percentual</button
                    >
                </div>
                {#if type === 'fixed'}
                    <div class="input-group">
                        <label for="" class="input-group-text">Desconto Fixo {window.configs.currency}</label>
                        <input bind:this={inputFixed} type="number" bind:value={discount} class="form-control" />
                    </div>
                {:else}
                    <div class="input-group">
                        <label for="" class="input-group-text">Desconto Percentual %</label>
                        <input bind:this={inputPercentage} type="number" bind:value={discount} class="form-control" />
                    </div>
                {/if}
            </div>
        </div>
    </div>
</div>

<style>
    .row {
        padding: 0px 16px;
    }

    @media (max-width: 900px) {
        .root {
            display: flex;
            flex-direction: column-reverse;
        }
        .grid-act {
            background-color: unset;
            display: flex;
            justify-content: space-around;
        }
        .grid-act .btn {
            max-width: 120px;
            flex-grow: 1;
        }
    }
</style>
